import React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CustomModalLayout = ({
  open,
  onClose,
  title,
  subTitle,
  componentToPass,
  width = "550px",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="paper"
      className="custom-model-wrapper"
      PaperProps={{
        className: "custom-model-paper",
        style: {
          width: width,
          maxWidth: "90%",
        },
      }}
    >
      {/* Modal Header */}
      <DialogTitle className="border-bottom">
        <div className="d-flex justify-content-between align-items-center">
          <h4 className="model-title m-0">{title}</h4>
          <div onClick={onClose} className="model-red-cross">
            <CloseIcon />
          </div>{" "}
        </div>
        {subTitle && <p className="model-sub-title">{subTitle}</p>}
      </DialogTitle>

      {/* Modal Body */}
      <DialogContent className="p-4 card-1 custom-modal-content">
        {componentToPass}
      </DialogContent>
    </Dialog>
  );
};

export default CustomModalLayout;
